import { AlertCircle } from "lucide-react";
import {Image_Url} from "../config/index.js"
export const getInitials = (name="")=>{
    return name.trim().split(" ").map(word=> word[0]?.toUpperCase()).slice(0,2).join("")
}

export const validateRequired = (value) => {
  if (value === null || value === undefined) return false;

  return String(value).trim().length > 0;
};


export const ErrorMessage = ({ message }) => {
  if (!message) return null;

  const text =
    typeof message === "string"
      ? message
      : message?.message || "Something went wrong";

  return (
    <div className="flex items-center gap-1 mt-1 text-red-500 text-sm">
      <AlertCircle size={14} />
      <span>{text}</span>
    </div>
  );
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

//  export const validatePhone = (phone) => {
//   const phoneRegex = /^[\+]?[\d\s\-\(\)]{10,}$/;
//   return phoneRegex.test(phone.replace(/\s/g, ''));
// };
export const validatePhone = (phone = "") => {
  const trimmed = phone.trim();
  // Allows +91XXXXXXXXXX, +1XXXXXXXXXX, 10–15 digits total
  return /^\+?[1-9]\d{9,15}$/.test(trimmed);
};


export const validateZipCode = (zipcode) => {
  const zipRegex = /^\d{6}$/;
  return zipRegex.test(zipcode);
};


export const validateNumeric = (value) => {
  if (!value || value.trim() === '') return false;
  const num = parseFloat(value);
  return !isNaN(num) && num >= 0;
};

export const validatePercentage = (value) => {
  if (value === '' || value === null || value === undefined) return false;

  const num = Number(value);
  return !isNaN(num) && num >= 0 && num <= 100;
};

export const renderImages = (path)=>{
  return `${Image_Url}${path}`
}

const IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];
export const validateFileType = (file) => {
  if (!file) return false;
  return IMAGE_TYPES.includes(file.type);
};
export const validateFileSize = (file, maxSizeMB = 5) => {
  if (!file) return false;
  const maxSize = maxSizeMB * 1024 * 1024; // MB → bytes
  return file.size <= maxSize;
};

export const validateImageFile = (file, maxSizeMB = 5) => {
  if (!file) return "Image is required";

  if (!validateFileType(file)) {
    return "Image must be PNG, JPG, or WebP";
  }

  if (!validateFileSize(file, maxSizeMB)) {
    return `Image must be less than ${maxSizeMB}MB`;
  }

  return ""; // ✅ valid
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "" || value === 0) return "-";

  const cleaned = String(value).replace(/[^0-9.]/g, "");
  if (!cleaned) return "";

  const num = Number(cleaned);
  if (isNaN(num)) return "";

  // count decimals from original value
  const decimalPart = cleaned.split(".")[1];
  const decimals = decimalPart ? decimalPart.length : 0;

  return `$${num.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
};


export const formatWithCommas = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  // Convert to string & clean (keep digits and decimal)
  const cleaned = String(value).replace(/[^0-9.]/g, "");
  if (!cleaned) return "-";

  const num = Number(cleaned);
  if (isNaN(num)) return "-";

  // Preserve decimals if present
  const decimalPart = cleaned.split(".")[1];
  const decimals = decimalPart ? decimalPart.length : 0;

  return num.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};


export const formatWithPercent = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  // Convert to string and clean (keep digits + decimal)
  const cleaned = String(value).replace(/[^0-9.]/g, "");
  if (!cleaned) return "-";

  const num = Number(cleaned);
  if (isNaN(num)) return "-";

  // Preserve decimals from original value
  const decimalPart = cleaned.split(".")[1];
  const decimals = decimalPart ? decimalPart.length : 0;

  const formatted = num.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return `${formatted}%`;
};


export function formatTimestamp(timestamp) {
  if (!timestamp) return "-"; // or "", or null

  const date = new Date(timestamp);

  if (isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

 export function formatTimestampWithTime(timestamp) {
  if (!timestamp) return "-";

  const date = new Date(timestamp);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert 0 -> 12

  return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
}

